import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';
import { SessionView } from 'src/app/services/session-shared-data.service';

/**
 * This service is used to manage some states of video call tiles.
 * Used by:
 * - video call participant id component
 * - full screen app manager service
 */
@Injectable()
@UntilDestroy()
export class VideoCallTileStateManagerService {
  private _callConnected = false;
  private _currentSessionView$ = new BehaviorSubject(SessionView.WHITEBOARD);
  readonly currentSessionView$ = this._currentSessionView$.asObservable();

  set currentSessionView(sessionView: SessionView) {
    this._currentSessionView$.next(sessionView);
  }

  get currentSessionView(): SessionView {
    return this._currentSessionView$.getValue();
  }

  set callConnected(callConnected: boolean) {
    this._callConnected = callConnected;
  }

  get callConnected(): boolean {
    return this._callConnected;
  }
}
